import { retrieveErrorFromApi } from '../../../helper'
import { setWatches } from '../../action/watch'
import { setAppErrors } from '../../action/system'
import getWatches from '../../axios/posNotification/watch/getWatches'
import generateWatchPairingCode from '../../axios/posNotification/watch/generateWatchPairingCode'
import deleteWatch from '../../axios/posNotification/watch/deleteWatch'

export const fetchWatchesThunk = () => dispatch => {
	return getWatches()
		.then(res => {
			dispatch(setWatches(res.data))
		}).catch(error => {
			dispatch(setAppErrors(retrieveErrorFromApi(error)))
		})
}

export const generatePairingCodeThunk = () => dispatch => {
	return generateWatchPairingCode()
		.then(res => {
			return res.data
		}).catch(error => {
			dispatch(setAppErrors(retrieveErrorFromApi(error)))
		})
}

export const deleteWatchThunk = (watchId) => dispatch => {
	return deleteWatch(watchId)
		.then(() => {
			return dispatch(fetchWatchesThunk())
		}).catch(error => {
			dispatch(setAppErrors(retrieveErrorFromApi(error)))
		})
}
